/**
 * Filename → media type, in one place.
 *
 * This existed three times: the ingest worker (correctly, via F.KIND), the
 * preview reader and the chat bubble. The preview copy hardcoded the kind
 * numbers instead of importing them — `jpg: 2` when IMAGE is 1 and VIDEO is 2 —
 * so every photo got a blob labelled `video/mp4`.
 *
 * Chrome sniffs the bytes and renders it regardless. WebKit believes the type
 * it was given, tries to decode a JPEG as MP4, and shows a broken image. So the
 * bug was invisible in every test and every browser used to build this, and
 * plainly visible to the first person who opened it on an iPhone.
 */
export const MIME_BY_EXT: Record<string, string> = {
  jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png', webp: 'image/webp',
  gif: 'image/gif', heic: 'image/heic', heif: 'image/heif',
  tif: 'image/tiff', tiff: 'image/tiff', bmp: 'image/bmp',

  mp4: 'video/mp4', mov: 'video/quicktime', '3gp': 'video/3gpp',
  m4v: 'video/x-m4v', avi: 'video/x-msvideo', mkv: 'video/x-matroska',
  webm: 'video/webm',

  opus: 'audio/ogg', ogg: 'audio/ogg', m4a: 'audio/mp4', mp3: 'audio/mpeg',
  aac: 'audio/aac', caf: 'audio/x-caf', amr: 'audio/amr', wav: 'audio/wav',

  pdf: 'application/pdf', txt: 'text/plain', vcf: 'text/vcard',
};

/** The type a browser should be told, from the name alone. */
export const mimeForFilename = (name: string) =>
  MIME_BY_EXT[name.split('.').pop()?.toLowerCase() ?? ''] ?? 'application/octet-stream';
